module.exports = __webpack_public_path__ + "static/media/AUFS_Logo_FR.62d8c4b3.png";